// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getSupabaseRuntimeConfig } from './runtimeConfig';

const { url: SUPABASE_URL, key: SUPABASE_KEY } = getSupabaseRuntimeConfig();

if (!SUPABASE_URL || !SUPABASE_KEY) {
  throw new Error('Missing or invalid Supabase runtime configuration');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
